import { AfterViewInit, Component, ElementRef, EventEmitter, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { NavigationItem } from '../navigation';
import { NextConfig } from '../../../../../app-config';
import { Location } from '@angular/common';
import { HomeService } from '../../../../../home/home.service';
import { SecurityHelper } from '../../../../../pages/common/securityHelper';

@Component({
  standalone: false,
  selector: 'app-nav-content',
  templateUrl: './nav-content.component.html',
  styleUrls: ['./nav-content.component.scss']
})
export class NavContentComponent implements OnInit, AfterViewInit {
  public nextConfig: any;
  public navigation: any;
  public prevDisabled: string;
  public nextDisabled: string;
  public contentWidth: number;
  public wrapperWidth: any;
  public scrollWidth: any;
  public windowWidth: number;
  isOpen: boolean = true;

  contentCategoryList: any[] = [];

  @Output() onNavMobCollapse = new EventEmitter();

  @ViewChild('navbarContent', { static: false }) navbarContent!: ElementRef;
  @ViewChild('navbarWrapper', { static: false }) navbarWrapper!: ElementRef;

  constructor(public nav: NavigationItem, private zone: NgZone, private location: Location, private homeService: HomeService,) {
    this.nextConfig = NextConfig.config;
    this.windowWidth = window.innerWidth;

    this.navigation = this.nav.get();
    this.prevDisabled = 'disabled';
    this.nextDisabled = '';
    this.scrollWidth = 0;
    this.contentWidth = 0;
  }

  ngOnInit() {
    // set root url  (path refering to AdminComponent in app-routing.module)
    let root = 'admin'
    if (this.windowWidth < 992) {
      this.nextConfig['layout'] = 'vertical';
      setTimeout(() => {
        document.querySelector('.pcoded-navbar')!.classList.add('menupos-static');
        (document.querySelector('#nav-ps-next') as HTMLElement).style.maxHeight = '100%';
      }, 500);
    }
    this.getContentCategoryList().then(() => {
      let allowContentFeatures: boolean = true;
      if (SecurityHelper.GetLightVersion()) {
        allowContentFeatures = false;
      }
      this.navigation[0].children[0].children = [];
      this.contentCategoryList.forEach(x => {
        if (x.isReminder != true && allowContentFeatures) {
          let content = {
            id: x.contentCategoryID,
            moduleAccessID: 0,
            title: x.contentCategoryName,
            type: 'item',
            url: `/${root}/home`,
            breadcrumbs: false,
          }
          this.navigation[0].children[0].children.push(content);
        }
      })
    })

  }

  ngAfterViewInit() {
    if (this.nextConfig['layout'] === 'horizontal') {
      this.contentWidth = this.navbarContent.nativeElement.clientWidth;
      this.wrapperWidth = this.navbarWrapper.nativeElement.clientWidth;
    }
  }

  scrollPlus() {
    //this.scrollWidth = this.scrollWidth + (this.wrapperWidth - 80);
    this.scrollWidth = this.scrollWidth + 500;
    if (this.scrollWidth > (this.contentWidth - this.wrapperWidth)) {
      this.scrollWidth = this.contentWidth - this.wrapperWidth + 80;
      this.nextDisabled = 'disabled';
    }
    this.prevDisabled = '';
    if (this.nextConfig.rtlLayout) {
      (document.querySelector('#side-nav-horizontal') as HTMLElement).style.marginRight = '-' + this.scrollWidth + 'px';
    } else {
      (document.querySelector('#side-nav-horizontal') as HTMLElement).style.marginLeft = '-' + this.scrollWidth + 'px';
    }
  }

  scrollMinus() {
    this.scrollWidth = this.scrollWidth - this.wrapperWidth;
    if (this.scrollWidth < 0) {
      this.scrollWidth = 0;
      this.prevDisabled = 'disabled';
    }
    this.nextDisabled = '';
    if (this.nextConfig.rtlLayout) {
      (document.querySelector('#side-nav-horizontal') as HTMLElement).style.marginRight = '-' + this.scrollWidth + 'px';
    } else {
      (document.querySelector('#side-nav-horizontal') as HTMLElement).style.marginLeft = '-' + this.scrollWidth + 'px';
    }

  }

  fireLeave() {
    const sections = document.querySelectorAll('.pcoded-hasmenu');
    for (let i = 0; i < sections.length; i++) {
      sections[i].classList.remove('active');
      sections[i].classList.remove('pcoded-trigger');
    }

    let current_url = this.location.path();
    //if (this.location['_baseHref']) {
    //  current_url = this.location['_baseHref'] + this.location.path();
    //}
    //does not work in angular 16, assume baseHerf is unused
    const link = "a.nav-link[ href='" + current_url + "' ]";
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent: any = ele.parentElement;
      const up_parent = parent.parentElement.parentElement;
      const last_parent = up_parent.parentElement;
      if (parent.classList.contains('pcoded-hasmenu')) {
        parent.classList.add('active');
      } else if (up_parent.classList.contains('pcoded-hasmenu')) {
        up_parent.classList.add('active');
      } else if (last_parent.classList.contains('pcoded-hasmenu')) {
        last_parent.classList.add('active');
      }
    }
  }

  navMob() {
    if (this.windowWidth < 992 && document.querySelector('app-navigation.pcoded-navbar')!.classList.contains('mob-open')) {
      this.onNavMobCollapse.emit();
    }
  }

  fireOutClick() {
    let current_url = this.location.path();
    this.isOpen = !(document.querySelector('app-navigation.pcoded-navbar')!.classList.contains('navbar-collapsed'));
    //if (this.location['_baseHref']) {
    //  current_url = this.location['_baseHref'] + this.location.path();
    //}
    //does not work in angular 16, assume baseHerf is unused
    const link = "a.nav-link[ href='" + current_url + "' ]";
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent: any = ele.parentElement;
      const up_parent = parent.parentElement.parentElement;
      const last_parent = up_parent.parentElement;
      if (parent.classList.contains('pcoded-hasmenu')) {
        if (this.nextConfig['layout'] === 'vertical') {
          parent.classList.add('pcoded-trigger');
        }
        parent.classList.add('active');
      } else if (up_parent.classList.contains('pcoded-hasmenu')) {
        if (this.nextConfig['layout'] === 'vertical') {
          up_parent.classList.add('pcoded-trigger');
        }
        up_parent.classList.add('active');
      } else if (last_parent.classList.contains('pcoded-hasmenu')) {
        if (this.nextConfig['layout'] === 'vertical') {
          last_parent.classList.add('pcoded-trigger');
        }
        last_parent.classList.add('active');
      }
    }
  }
  getContentCategoryList(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.homeService.getContentCategoryList('ALL').subscribe(
        (res: any) => {
          if (this.isResponseValid(res)) {
            this.contentCategoryList = res.entity.list;
            resolve(true);
          }
        }
      )
    });
    return promise;
  }

  isResponseValid(res:any): boolean {
    let isValid = true;

    if (res.errorMessage.length > 0) {
      isValid = false;
      this.handleError(res.errorMessage[0]);
    }

    return isValid;
  }
  handleError(error: any) {
    let errorTitle = error.name ? error.name : 'Error';
    let errorMessage = error.message ? error.message : JSON.stringify(error);

    //swal.fire({
    //  title: errorTitle,
    //  html: '<span>' + errorMessage + '</span>',
    //  icon: "error",
    //  showCloseButton: true,
    //  allowOutsideClick: false,
    //  allowEscapeKey: false
    //});
    //// reset API retry count
    //this.countAPIRetry = 0;
  }
}
